import { fetcher } from "./apiClient";

export const getDropProgram = async () => {
  return fetcher("/dropdown/program");
};

export const getDropSubProgram = async (programId: string) => {
  return fetcher("/dropdown/program-sub?program=" + programId);
};

export const getDropOrganization = async () => {
  return fetcher("/dropdown/organization");
};

